// src/Thanks.js
import React, { useState, useEffect, useRef } from 'react';
import AnimateOnScroll from './../../components/common/animate';
import { Link, useNavigate } from 'react-router-dom';

import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';

export default function Thanks() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState({});
  const navigate = useNavigate();
  const hasFetched = useRef(false); // ⬅️ Moved useRef here

  const getPages = () => {
    setLoading(true);
    DataService.getPages()
      .then((response) => {
        const pages = response.data;
        const appointmentBookingPage = pages.find(
          (page) => page.page_name === 'Appointment Confirmation'
        );
        setPage(appointmentBookingPage || {});
      })
      .catch((error) => {
        console.error('Failed to fetch pages:', error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!hasFetched.current) {
      getPages();
      hasFetched.current = true;
    }
  }, []);

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div>
        {/* Hero Section */}
        <section
          className="hero-wrap hero-wrap-2"
          style={{ backgroundImage: "url('images/thank-you.png')" }}
          data-stellar-background-ratio="0.5"
        >
          <div className="overlay" />
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
              <AnimateOnScroll className="col-md-9 text-center">
                <h1 className="mb-3 bread"> {page.banner_title}</h1>
              </AnimateOnScroll>
            </div>
          </div>
        </section>

        {/* Booking Confirmation Message */}
        <section className="ftco-section thankyou-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 text-center">
                <h1 className="heading mb-4">
                 {page.title}
                </h1>
                {page?.message && (
                  <div
                    dangerouslySetInnerHTML={{ __html: page.message }}
                  />
                )}

                <div className="justify-content-center mt-5 thank-yout-btn">
                  <button
                    className="btn btn-primary py-3 px-5 mr-3"
                    onClick={() => navigate('/')}
                  >
                    Back to Home
                  </button>
                  <button
                    className="btn btn-secondary py-3 px-5 mr-3"
                    onClick={() => navigate('/book-appointment')}
                  >
                    Book Another
                  </button>
                  <button
                    className="btn btn-outline-primary py-3 px-5"
                    onClick={() => navigate('/contact')}
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
